export default __webpack_public_path__ + "static/media/Artes-Musica.6f8e3dbb.png";